import React from 'react';

import usePrefix from 'utils/usePrefix';
import { UserType } from 'utils/api/users';
import { userRoles } from 'utils/userRoles';
import useDefaultFormikValue from 'utils/useDefaultFormikValue';
import FormikSelect, { FormikSelectOption } from 'components/FormikSelect';

interface Props {
  name: string;
  margin?: string;
  isDisabled?: boolean;
  defaultValue?: UserType;
}

const RoleSelect: React.FC<Props> = ({ name, margin = '0', isDisabled = false, defaultValue }) => {
  const t = usePrefix('General');

  useDefaultFormikValue<UserType>(name, defaultValue);

  const roleOptions: Array<FormikSelectOption<UserType>> = [
    { value: userRoles.admin, label: t(userRoles.admin) },
    { value: userRoles.intervener, label: t(userRoles.intervener) },
    { value: userRoles.director, label: t(userRoles.director) },
  ];

  return (
    <FormikSelect<UserType>
      name={name}
      label={t('role')}
      placeholder={t('role')}
      options={roleOptions}
      margin={margin}
      isDisabled={isDisabled}
    />
  );
};

export default RoleSelect;
